import { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import NavItem from '../components/navbar/NavItem';
import navItems from '../data/navItems.json';
import Logo from '../assets/siasat-logo-2.png'; // Adjust path as needed

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  return (
    <header className="border-b border-gray-300 fixed top-0 right-0 left-0 bg-white z-50 shadow-sm">
      <div className="w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between lg:justify-start">

          {/* Logo */}
          <Link to="/" onClick={closeMenu}>
            <img
              src={Logo}
              alt="Logo"
              className="w-auto h-16 my-1 rounded-xl cursor-pointer"
            />
          </Link>

          {/* Mobile Menu Toggle (visible only on mobile) */}
          <button
            className="lg:hidden text-gray-600 focus:outline-none"
            onClick={toggleMenu}
            aria-label={isOpen ? 'Close menu' : 'Open menu'}
          >
            {isOpen ? (
              <FiX size={32} />
            ) : (
              <FiMenu size={32} />
            )}
          </button>

          {/* Navigation */}
          <nav
            className={`${isOpen ? 'block' : 'hidden'
              } lg:flex lg:items-center absolute lg:static top-full left-0 right-0 bg-white lg:bg-transparent shadow-lg lg:shadow-none transition-all duration-300`}
          >
            <ul className="flex flex-col lg:flex-row lg:items-center divide-y lg:divide-y-0 lg:gap-2">
              {navItems.map((item) => (
                <NavItem
                  key={item.path}
                  label={item.label}
                  path={item.path}
                  onClick={closeMenu}
                />
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Navbar;